import React, { Fragment } from "react"
import { Grid, Modal } from "semantic-ui-react";
import { isMobile } from "@utils/Helpers";
import { ModalWrapper, VTWrapper } from "./LeadGenSignup.styles";
import { KpFormDropdown, KpFormField } from "@styles/Global.forms";
import { KpButton } from "@components/elements/index";
import { ButtonTypes } from "@utils/Constant";
import theme from "@styles/theme";

interface LeadGenSignupState {
    emailIsValid?: boolean
    currentEmail: string
    validatingEmail: boolean,
    vtOptions: any,
    vtData: any,
    formData: any,
    isSubmitting: boolean
}

interface LeadGenSignupProps {
    apiUrl:string
    onClose: Function,
    modalOpen: boolean,
    combination: string,
    carMake: any,
    motorbikeMake: any,
    trailerMake: any,
    handleSignup: any
}

class LeadGenSignup extends React.Component<LeadGenSignupProps,LeadGenSignupState>{

    constructor(props:LeadGenSignupProps){
        super(props);
        this.state = {
            currentEmail: "",
            emailIsValid: false,
            validatingEmail: false,
            vtOptions: {
              carMake: 'vt-active'
            },
            vtData: this.props.carMake,
            formData: {
              vehicleType: "Car",
              vehicleTypeId: 1
            },
            isSubmitting: false
        }
    }


    handleClose = () => {
        this.props.onClose();
    }

    handleSubmit = () => {
      this.setState({isSubmitting: true})
      this.props.handleSignup(this.state.formData);
    }

    handleVtOptions = (field: string, value: string) => {
      var formData: any = {}
      var vtOptions: any = {}
      vtOptions[field] = value

      var vtData = this.state.vtData
      switch (field) {
        case 'carMake':
          formData.vehicleType = "Car"
          formData.vehicleTypeId = 1
          vtData = this.props.carMake
          break;
        case 'motorbikeMake':
          vtData = this.props.motorbikeMake
          formData.vehicleType = "MotorBike"
          formData.vehicleTypeId = 2
          break;
        case 'trailerMake':
          vtData = this.props.trailerMake
          formData.vehicleType = "Trailer"
          formData.vehicleTypeId = 3
          break;
        default:
          break;
      }


      this.setState({
        vtOptions: vtOptions,
        vtData: vtData,
        formData: formData
      })
    }

    handleFormData = (field: string, value: string) => {
      var formData = this.state.formData
      formData[field] = value
      this.setState({formData: formData})
    }

    render() {
        return (
            <Modal className="lead-gen-modal" open={this.props.modalOpen} onClose={this.handleClose} centered={true} size={isMobile() ? "fullscreen" : "tiny"}>

                <ModalWrapper>
                <div className="close" onClick={this.handleClose}>
                  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.3828 2.88281C12.8711 2.39453 12.8711 1.60156 12.3828 1.11328C11.8945 0.625 11.1016 0.625 10.6133 1.11328L6.5 5.23047L2.38281 1.11719C1.89453 0.628906 1.10156 0.628906 0.613281 1.11719C0.125 1.60547 0.125 2.39844 0.613281 2.88672L4.73047 7L0.617188 11.1172C0.128906 11.6055 0.128906 12.3984 0.617188 12.8867C1.10547 13.375 1.89844 13.375 2.38672 12.8867L6.5 8.76953L10.6172 12.8828C11.1055 13.3711 11.8984 13.3711 12.3867 12.8828C12.875 12.3945 12.875 11.6016 12.3867 11.1133L8.26953 7L12.3828 2.88281Z" fill="#707070"/>
                  </svg>
                </div>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div className="title">Sign Up for News & Deals</div>
                    <div className="summary">What vehicle type are you buying a plate for?</div>
                    <div style={{padding: "20px"}}>
                      <Grid width={16}>
                        <Grid.Row  style={{display:"contents"}} >
                          <Grid.Column
                            mobile={16}
                            tablet={16}
                            computer={16}
                            textAlign="center"
                          >
                            <KpFormField>
                              <VTWrapper className="flex mb-1">
                                <svg className={this.state.vtOptions.carMake || ''} onClick={() => this.handleVtOptions('carMake', 'vt-active')} width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.42375 2.28571H8.4V5.71429H4.17375L5.31375 3.00357C5.49375 2.57143 5.9325 2.28571 6.42375 2.28571ZM10.2 5.71429V2.28571H13.245C13.6088 2.28571 13.9538 2.44286 14.1825 2.71429L16.7025 5.71429H10.2ZM19.8075 5.75L16.0575 1.28571C15.375 0.471429 14.34 0 13.245 0H6.42375C4.95 0 3.62625 0.853572 3.0825 2.15357L1.5225 5.87143C0.63 6.20714 0 7.03214 0 8V12C0 12.6321 0.53625 13.1429 1.2 13.1429H2.44875C2.73375 14.7643 4.215 16 6 16C7.785 16 9.26625 14.7643 9.55125 13.1429H14.4488C14.7338 14.7643 16.215 16 18 16C19.785 16 21.2663 14.7643 21.5513 13.1429H22.8C23.4638 13.1429 24 12.6321 24 12V10.2857C24 7.95714 22.17 6.03571 19.8075 5.75ZM16.3013 12C16.3776 11.7849 16.4982 11.5863 16.6558 11.4159C16.8134 11.2455 17.0051 11.1066 17.2195 11.0073C17.434 10.9081 17.6671 10.8504 17.9052 10.8376C18.1432 10.8248 18.3816 10.8572 18.6065 10.9329C18.8313 11.0086 19.0381 11.1261 19.2148 11.2786C19.3915 11.4311 19.5347 11.6155 19.636 11.8211C19.7373 12.0267 19.7946 12.2494 19.8048 12.4763C19.8149 12.7032 19.7776 12.9298 19.695 13.1429C19.6186 13.358 19.4981 13.5565 19.3405 13.727C19.1828 13.8974 18.9912 14.0362 18.7767 14.1355C18.5622 14.2348 18.3292 14.2925 18.0911 14.3053C17.853 14.318 17.6146 14.2856 17.3898 14.2099C17.165 14.1342 16.9582 14.0167 16.7814 13.8642C16.6047 13.7118 16.4615 13.5274 16.3603 13.3218C16.259 13.1162 16.2016 12.8934 16.1915 12.6665C16.1814 12.4396 16.2187 12.2131 16.3013 12ZM6 10.8571C6.47739 10.8571 6.93523 11.0378 7.27279 11.3592C7.61036 11.6807 7.8 12.1168 7.8 12.5714C7.8 13.0261 7.61036 13.4621 7.27279 13.7836C6.93523 14.1051 6.47739 14.2857 6 14.2857C5.52261 14.2857 5.06477 14.1051 4.72721 13.7836C4.38964 13.4621 4.2 13.0261 4.2 12.5714C4.2 12.1168 4.38964 11.6807 4.72721 11.3592C5.06477 11.0378 5.52261 10.8571 6 10.8571Z" fill="#707070"/>
                                </svg>
                                <svg className={this.state.vtOptions.trailerMake || ''} onClick={() => this.handleVtOptions('trailerMake', 'vt-active')}  width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.725 0C0.772656 0 0 0.767857 0 1.71429V10.8571C0 11.8036 0.772656 12.5714 1.725 12.5714H2.33953C2.61984 10.6321 4.29453 9.14286 6.325 9.14286C8.35547 9.14286 10.0302 10.6321 10.3105 12.5714H17.5375H17.825H21.85C22.4861 12.5714 23 12.0607 23 11.4286C23 10.7964 22.4861 10.2857 21.85 10.2857H19.55V1.71429C19.55 0.767857 18.7773 0 17.825 0H1.725ZM2.875 2.28571C3.19125 2.28571 3.45 2.54286 3.45 2.85714V7.54286C3.04031 7.75357 2.65219 8.00357 2.3 8.29286V2.85714C2.3 2.54286 2.55875 2.28571 2.875 2.28571ZM6.325 6.85714C6.13094 6.85714 5.94047 6.86429 5.75 6.88214V2.85714C5.75 2.54286 6.00875 2.28571 6.325 2.28571C6.64125 2.28571 6.9 2.54286 6.9 2.85714V6.88214C6.70953 6.86429 6.51906 6.85714 6.325 6.85714ZM9.2 7.54286V2.85714C9.2 2.54286 9.45875 2.28571 9.775 2.28571C10.0912 2.28571 10.35 2.54286 10.35 2.85714V8.29286C9.99781 8.00357 9.60969 7.75 9.2 7.54286ZM13.225 2.28571C13.5412 2.28571 13.8 2.54286 13.8 2.85714V9.71429C13.8 10.0286 13.5412 10.2857 13.225 10.2857C12.9087 10.2857 12.65 10.0286 12.65 9.71429V2.85714C12.65 2.54286 12.9087 2.28571 13.225 2.28571ZM17.25 2.85714V9.71429C17.25 10.0286 16.9912 10.2857 16.675 10.2857C16.3587 10.2857 16.1 10.0286 16.1 9.71429V2.85714C16.1 2.54286 16.3587 2.28571 16.675 2.28571C16.9912 2.28571 17.25 2.54286 17.25 2.85714ZM6.325 16C7.0875 16 7.81876 15.699 8.35793 15.1632C8.8971 14.6273 9.2 13.9006 9.2 13.1429C9.2 12.3851 8.8971 11.6584 8.35793 11.1226C7.81876 10.5867 7.0875 10.2857 6.325 10.2857C5.5625 10.2857 4.83123 10.5867 4.29207 11.1226C3.7529 11.6584 3.45 12.3851 3.45 13.1429C3.45 13.9006 3.7529 14.6273 4.29207 15.1632C4.83123 15.699 5.5625 16 6.325 16ZM6.325 12C6.63 12 6.92251 12.1204 7.13817 12.3347C7.35384 12.5491 7.475 12.8398 7.475 13.1429C7.475 13.446 7.35384 13.7367 7.13817 13.951C6.92251 14.1653 6.63 14.2857 6.325 14.2857C6.02 14.2857 5.72749 14.1653 5.51183 13.951C5.29616 13.7367 5.175 13.446 5.175 13.1429C5.175 12.8398 5.29616 12.5491 5.51183 12.3347C5.72749 12.1204 6.02 12 6.325 12Z" fill="#707070"/>
                                </svg>
                                <svg className={this.state.vtOptions.motorbikeMake || ''} onClick={() => this.handleVtOptions('motorbikeMake', 'vt-active')}  width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.0625 0.00357065C9.58453 0.00357065 9.2 0.385628 9.2 0.860522C9.2 1.33542 9.58453 1.71747 10.0625 1.71747H12.1361L12.7255 2.79938L9.2 5.71658L7.57203 4.09908C7.14078 3.67061 6.555 3.43138 5.94406 3.43138H2.3C1.66391 3.43138 1.15 3.94198 1.15 4.57398V5.71658H4.6C7.77688 5.71658 10.35 8.27315 10.35 11.4296C10.35 11.8224 10.3105 12.2044 10.235 12.5722H12.765C12.6895 12.2044 12.65 11.8224 12.65 11.4296C12.65 9.56572 13.5484 7.90895 14.9392 6.86632L15.4927 7.88753C14.4613 8.72662 13.8 10.0013 13.8 11.4296C13.8 13.954 15.8592 16 18.4 16C20.9408 16 23 13.954 23 11.4296C23 8.90516 20.9408 6.85918 18.4 6.85918C17.9148 6.85918 17.4477 6.93417 17.0092 7.07342L15.0291 3.43138H17.25C17.8861 3.43138 18.4 2.92078 18.4 2.28877V1.14617C18.4 0.514171 17.8861 0.00357065 17.25 0.00357065H16.5169C16.2473 0.00357065 15.9886 0.0964071 15.7802 0.267797L14.0767 1.6782L13.5736 0.749833C13.322 0.289221 12.8369 0 12.3086 0H10.0625V0.00357065ZM16.6283 9.97277L17.6417 11.8366C17.8681 12.2544 18.3928 12.4079 18.8097 12.183C19.2266 11.958 19.3847 11.4367 19.1583 11.0225L18.1448 9.15867C18.2275 9.14796 18.3137 9.14439 18.4 9.14439C19.6686 9.14439 20.7 10.1692 20.7 11.4296C20.7 12.69 19.6686 13.7148 18.4 13.7148C17.1314 13.7148 16.1 12.69 16.1 11.4296C16.1 10.8761 16.2977 10.3691 16.6283 9.97277ZM6.73109 12.2865C6.38969 13.1256 5.56312 13.7148 4.6 13.7148C3.33141 13.7148 2.3 12.69 2.3 11.4296C2.3 10.1692 3.33141 9.14439 4.6 9.14439C5.56672 9.14439 6.39328 9.73354 6.73109 10.5726H9.11734C8.71484 8.45883 6.84609 6.85918 4.6 6.85918C2.05922 6.85918 0 8.90516 0 11.4296C0 13.954 2.05922 16 4.6 16C6.84609 16 8.71484 14.4004 9.12094 12.2865H6.73109ZM4.6 12.5722C4.905 12.5722 5.19751 12.4518 5.41317 12.2375C5.62884 12.0233 5.75 11.7326 5.75 11.4296C5.75 11.1266 5.62884 10.8359 5.41317 10.6217C5.19751 10.4074 4.905 10.287 4.6 10.287C4.295 10.287 4.00249 10.4074 3.78683 10.6217C3.57116 10.8359 3.45 11.1266 3.45 11.4296C3.45 11.7326 3.57116 12.0233 3.78683 12.2375C4.00249 12.4518 4.295 12.5722 4.6 12.5722Z" fill="#707070"/>
                                </svg>
                              </VTWrapper>
                              { (this.state.vtOptions.carMake || this.state.vtOptions.motorbikeMake) && <KpFormDropdown
                                fluid
                                selection
                                placeholder="Please Select Vehicle Make"
                                backgroundColor={theme.brand.colors.white}
                                icon="chevron down"
                                options={this.state.vtData}
                                value={this.state.formData['vehicleMake'] || null}
                                onChange={(e:any) => this.handleFormData('vehicleMake', e.currentTarget.innerText)}
                              />}
                            </KpFormField>
                          </Grid.Column>

                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column
                            mobile={16}
                            tablet={16}
                            computer={16}
                            textAlign="center"
                          >
                            <KpButton
                                id="signin-submit"
                                color={theme.brand.colors.green}
                                fullWidth="mobile tablet computer"
                                buttonType={ButtonTypes.Primary}
                                loading={this.state.isSubmitting}
                                type="submit"
                                onClick={this.handleSubmit}
                            >
                                DONE
                            </KpButton>
                          </Grid.Column>

                        </Grid.Row>
                      </Grid>
                    </div>
                    <div className="tnc"><a href="/terms-and-conditions/" target="_blank">
                        Terms and Conditions Apply
                      </a></div>
                    </Grid.Column>
                </ModalWrapper>
            </Modal>)

    }
}

export default LeadGenSignup